import { styled } from '@mui/material/styles';
import { Toolbar } from '@mui/material';

export const StyledRoot = styled(Toolbar)(({ theme }) => ({
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    gap: theme.spacing(1),
    overflow: 'hidden',
}));
